/** Conversation-level actions — pin/mute/block (H4 parity). */

import type { Contact, Conversation } from "./index";

export function togglePinnedConversation(c: Conversation): Conversation {
  return { ...c, pinned: !c.pinned };
}

export function toggleMutedConversation(c: Conversation): Conversation {
  return { ...c, muted: !c.muted };
}

/** Manual "Mark as read" — clears the local unread badge without opening the chat. */
export function markConversationRead(c: Conversation): Conversation {
  return { ...c, unread: 0 };
}

/**
 * Manual "Mark as unread" — surfaces the badge again. Reuses `unread` (min 1) so
 * the existing badge/muted styling and open-clears-read flow apply unchanged.
 */
export function markConversationUnread(c: Conversation): Conversation {
  return { ...c, unread: Math.max(1, c.unread) };
}

export function blockContact(contact: Contact, now = Date.now()): Contact {
  return { ...contact, blockedAt: now };
}

export function unblockContact(contact: Contact): Contact {
  const { blockedAt: _, ...rest } = contact;
  return { ...rest };
}

export function sortConversations(list: Conversation[], opts?: { includeArchived?: boolean }): Conversation[] {
  const filtered = opts?.includeArchived ? list : list.filter((c) => !c.archived);
  return [...filtered].sort((a, b) => {
    if (a.pinned !== b.pinned) return a.pinned ? -1 : 1;
    return (b.lastMessageAt || 0) - (a.lastMessageAt || 0);
  });
}
